<template lang="html">

    <Form  v-if="form" :label-width="200" @submit.native.prevent="post(form)" :model="form" :show-message="false">
      <!--<FormItem label="Numero socio" :rules="{required:true}" prop="number">
        <Input v-model="form.number"/>
      </FormItem>-->
      <FormItem label="Nome" :rules="{required:true}" prop="first_name">
        <Input v-model="form.first_name"/>
      </FormItem>
      <FormItem label="Cognome" :rules="{required:true}" prop="last_name">
        <Input v-model="form.last_name"/>
      </FormItem>
      <FormItem label="Data di nascita" :rules="{required:true}" prop="birth_date">
        <Input v-model="date_d" placeholder="GG" style="width: 50px"/>
        &nbsp;
        <Input v-model="date_m" placeholder="MM" style="width: 50px"/>
        &nbsp;
        <Input v-model="date_y" placeholder="AAAA" style="width: 100px"/>
        <!-- <LocalDate v-model="form.birth_date"/> -->
      </FormItem>
      <FormItem label="Codice fiscale">
        <Input v-model="form.cf"/>
      </FormItem>
      <FormItem label="Documento">
        <Input v-model="form.doc"/>
      </FormItem>
      <FormItem label="Indirizzo">
        <Input v-model="form.addr_street"/>
      </FormItem>
      <FormItem label="Città">
        <Input v-model="form.addr_city"/>
      </FormItem>
      <FormItem label="CAP">
        <Input v-model="form.addr_zip"/>
      </FormItem>
      <FormItem label="PROV">
        <Input v-model="form.addr_prov"/>
      </FormItem>
      
      <FormItem label="Paese di nascita">
        <Input v-model="form.birth_city"/>
      </FormItem>
      <FormItem label="Prov. di nascita">
        <Input v-model="form.birth_prov"/>
      </FormItem>
      <FormItem label="Email">
        <Input v-model="form.email" type="email"/>
      </FormItem>
      <FormItem label="PEC">
        <Input v-model="form.pec" type="email"/>
      </FormItem>
      <FormItem label="Telefono">
        <Input v-model="form.telephone"/>
      </FormItem>
      <FormItem label="Secondo telefono">
        <Input v-model="form.second_phone"/>
      </FormItem>
      <FormItem label="Note">
        <Input type="textarea" :rows="10" v-model="form.notes"/>
      </FormItem>
      <FormItem label="Campi modulo:" v-if="$store.company.module">

        <Form v-for="field in $store.company.module.fields" :key="field.name">
          <FormItem v-if="field.type == 'text'" :label="field.label">
            <Input required v-model="form.meta[field.name]" :placeholder="field.label"/>
          </FormItem>
          <FormItem v-if="field.type == 'check'">
            <Checkbox v-model="form.meta[field.name]" type="checkbox" size="large"  :true-value="1" :false-value="0">
              &nbsp;&nbsp;
              {{ field.label }}
            </Checkbox>
          </FormItem>
        </Form>
      </FormItem>
      <FormItem label="Altri campi:" v-if="$store.company.module">
        <div class="" v-for="(v, meta_name) in form.meta" v-if="!$store.company.module.fields.find(x => x.name == meta_name)">
          <Checkbox v-if="meta_name.match(/^check /)" v-model="form.meta[meta_name]" type="checkbox" :true-value="1" :false-value="0">
            &nbsp;&nbsp;
            {{ meta_name.replace(/-/g, ' ').replace(/^check /, '') }}
            <Icon type="trash-a" style="color: #f00; margin-left: .5rem; cursor:pointer;" @click="$delete(form.meta, meta_name)"/>
          </Checkbox>
          <div v-else>
            <b>{{ meta_name.replace(/-/g, ' ').replace(/^check /, '') }}:</b>
            <Icon type="trash-a" style="color: #f00; margin-left: .5rem; cursor:pointer;" @click="$delete(form.meta, meta_name)"/>
            <br>
            <Input v-model="form.meta[meta_name]"/>
          </div>
        </div>
      </FormItem>
      <FormItem v-if="$store.company.can_sign" class="nolabelmargin">
        <b>Firma digitale</b>
        <br>
        <vueSignature ref="signature"
        style="border: 1px solid #666"
        w="800px" h="400px"
        :sigOption="{ penColor:'rgb(0, 0, 0)', backgroundColor:'rgb(255,255,255)' }"/>

        <Button @click.native="clearSignature">Pulisci</Button>
      </FormItem>
      <input type="submit" style="display: none">
    </Form>
</template>

<script>
export default {
  
  props: ['form'],
  computed: {

    date_d: {
      get () { return parseInt((this.form.birth_date || '--').split('-')[2]) || '' },
      set (v) { if (isNaN(parseInt(v))) return;
         var s = (this.form.birth_date || '--').split('-')
        s[2] = v
        this.form.birth_date = s.join('-') },
    },
    date_m: {
      get () { return parseInt((this.form.birth_date || '--').split('-')[1]) || '' },
      set (v) { var s = (this.form.birth_date || '--').split('-')
        s[1] = v
        this.form.birth_date = s.join('-') },
    },
    date_y: {
      get () { return parseInt((this.form.birth_date || '--').split('-')[0]) || '' },
      set (v) { if (isNaN(parseInt(v))) return;
         var s = (this.form.birth_date || '--').split('-')
        s[0] = v
        this.form.birth_date = s.join('-') },
    },
  },
  mounted() {
    if (this.$store.company.can_sign) {
      setTimeout(() => {
        this.$refs.signature.clear()
        if (this.form.signature) {
          this.$http.get(`signatures/${this.form.signature}`).then(res => {
            if (!this.form) return
            this.sig_old = res.data ? res.data.length : 0
            res.data && this.$refs.signature.fromDataURL(res.data)
          })
        }
      }, 10)
    }
  },
  methods: {
    clearSignature () {
      this.form.signature = null
      this.form.signature_new = null
      this.$refs.signature.clear()
    },
    post(data) {
      console.log(this.$refs.associate_form)
      this.$refs.associate_form.validate((valid) => {
        if (valid) {
          data.company_id = this.$store.company.id
          var is_new = !data.id
          if (this.$store.company.can_sign) {
            if (!this.$refs.signature.isEmpty()) {
              var sig = this.$refs.signature.save()
              console.log(sig.length, this.sig_old)
              if (sig.length != this.sig_old) {
                data.signature_new = sig
              }
            } else {
              data.signature_new = ''
              data.signature = ''
            }
          }
          this.$parent.post(data)
        } else {
          this.$Message.error('Controllare gli errori');
        }
      })
    },
  }
}
</script>

<style lang="css" scoped>
</style>
